import React from "react";

function HomePageFeatureIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H16C22.6274 0 28 5.37258 28 12V16C28 22.6274 22.6274 28 16 28H12C5.37258 28 0 22.6274 0 16V12Z"
        fill="#EAECF0"
      />
      <path
        d="M17.125 21.8203V14.8203C17.125 14.5882 17.0328 14.3657 16.8687 14.2016C16.7046 14.0375 16.4821 13.9453 16.25 13.9453H12.75C12.5179 13.9453 12.2954 14.0375 12.1313 14.2016C11.9672 14.3657 11.875 14.5882 11.875 14.8203V21.8203"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.625 12.1957C6.62494 11.9412 6.68042 11.6897 6.78756 11.4587C6.89471 11.2278 7.05095 11.0231 7.24538 10.8587L13.3704 5.60873C13.6862 5.34178 14.0864 5.19531 14.5 5.19531C14.9136 5.19531 15.3138 5.34178 15.6296 5.60873L21.7546 10.8587C21.9491 11.0231 22.1053 11.2278 22.2124 11.4587C22.3196 11.6897 22.3751 11.9412 22.375 12.1957V20.0707C22.375 20.5349 22.1906 20.98 21.8624 21.3082C21.5342 21.6364 21.0891 21.8207 20.625 21.8207H8.375C7.91087 21.8207 7.46575 21.6364 7.13756 21.3082C6.80937 20.98 6.625 20.5349 6.625 20.0707V12.1957Z"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HomePageFeatureIcon;
